import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/zhuti1.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4ec8de3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "home_ban",
  src: "https://jsczxy.23544.com/pcimg/home_ban.png",
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "home_box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "home_banner",
  src: "https://jsczxy.23544.com/pcimg/home_ban1.png",
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "home_list" }
const _hoisted_6 = { class: "home_item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_title" }, "课程及资料", -1))
const _hoisted_8 = { class: "type_list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "type_pic" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_13 = { class: "type_txt" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "—", -1))
const _hoisted_15 = { class: "type_title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "home_down",
  src: "https://jsczxy.23544.com/pcimg/home_down.png",
  alt: ""
}, null, -1))

import { onMounted, reactive, toRaw, toRefs } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex';
import dataInit from '../recorded_broadcast/hooks/record_menu' // 混入录播菜单栏
import databanks from '../databank/hooks/data_menu' // 混入资料库菜单栏
import bus from '@/utils/bus';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { recordMenu, GetRecordMenu } = dataInit()
const { dataMenu, GetDataMenu } = databanks()
// 初始化
let person: any = reactive({
    typeList:[]
})
const router=useRouter()
const store = useStore()
onMounted(() => {
    // 判断是主页，头部不加背景色
    if (router.currentRoute.value.name === 'teaIndex') {
        store.commit('setIsBg',false)
    }
    getMenu()
})

const getMenu = async ()=>{
    // 获取录播菜单列表
    let menu1 = await GetRecordMenu(0, 1)
    // 获取资料库菜单列表
    let menu = await GetDataMenu(0, 1)
    // menu.forEach((x:any) => {
    //     x.PageType =4
    // });
    person.typeList = [...menu1, ...menu]
   
    localStorage.setItem("navList",JSON.stringify(person.typeList))
}

// 进入列表页
const toDetail=(item:any,index:number)=>{
    if (item.AliasName ==='配套资料'){
        router.push({ name: 'databank', query: { Id: item.Id, AliasName: item.AliasName } })
    }else{
        router.push({ name: 'recordedBroadcast', query: { Id: item.Id, AliasName: item.AliasName } })
    }
    bus.emit('navActive', index)
    localStorage.setItem("navActive",JSON.stringify(index))
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(person).typeList, (type, tyIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "type_item",
                key: tyIndex,
                onClick: ($event: any) => (toDetail(type,tyIndex))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  (type.CoverUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: type.CoverUrl,
                        alt: ""
                      }, null, 8, _hoisted_11))
                    : (_openBlock(), _createElementBlock("img", _hoisted_12)),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("p", null, _toDisplayString(type.AliasName ? type.AliasName:'暂无类别'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, _toDisplayString(type.Name), 1)
              ], 8, _hoisted_9))
            }), 128))
          ])
        ])
      ])
    ]),
    _hoisted_16
  ]))
}
}

})